/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMi41IDEyVjExLjE2MDlINS4yOTQ1NUw3Ljk3NTIyIDIuODM5MDZINS4xNjY2MlYySDExLjVWMi44MzkwNkg4LjgwMTY0TDYuMTEzNjYgMTEuMTYwOUg4LjgzMzU3VjEySDIuNVoiIGZpbGw9ImJsYWNrIi8+PC9zdmc+";